import { render, staticRenderFns } from "./OrganContactPersonEdit.vue?vue&type=template&id=588ee20a&scoped=true"
import script from "./OrganContactPersonEdit.vue?vue&type=script&lang=js"
export * from "./OrganContactPersonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ee20a",
  null
  
)

export default component.exports